import prettyBytes from "pretty-bytes";
import { FaEye } from "react-icons/fa";
import { Link } from "@tanstack/react-router";

import { JobStatus } from "../../apiClient";

import RapidDownloadOption from "../dataAsset/rapidDownloadOption";
import {
  ArchiveDownloadOption,
  GenerateArchiveOption,
  ArchiveIsGeneratingNonOption,
} from "../dataAsset/archiveOptions";

import Card from "./card";

export const DataSetOverviewCard = ({
  dataSet,
  showDownloadLinks,
  showDetailLink,
  refreshQuery = () => {},
}: { dataSet: any; showDownloadLinks: boolean; showDetailLink: boolean; refreshQuery?: () => void }) => {
  const totalSize = dataSet.total_data_volume;
  const totalFileCount = dataSet.number_of_assets;

  let ArchiveComponent: React.ComponentType<{ dataSet: any; refreshQuery?: () => void }> | null = null;
  switch (!!dataSet.export?.full_export_job) {
    case false:
      ArchiveComponent = GenerateArchiveOption;
      break;
    case true:
      switch (dataSet.export.full_export_job.status) {
        case JobStatus.SUCCESS:
          ArchiveComponent = ArchiveDownloadOption;
          break;
        case JobStatus.RUNNING:
          ArchiveComponent = ArchiveIsGeneratingNonOption;
          break;
        case JobStatus.FAILURE:
          ArchiveComponent = GenerateArchiveOption;
          break;
      }
  }

  return (
    <Card className="flex flex-row">
      <div className="flex-grow">
        <Link to={`/data/sets/${dataSet.public_id}` as any} className={"mb-4 text-2xl text-blue-200"}>{dataSet.name}</Link>
        <p className="max-w-fit font-light text-blue-400">
          {dataSet.description}
        </p>
        <div className="mt-4 flex flex-row items-center gap-6">
          <p className="font-heavy">
            {totalFileCount.toLocaleString()} data assets
          </p>
          <p className="font-heavy">{prettyBytes(totalSize)}</p>
          {showDetailLink && <div className={"grow"} />}
          {showDetailLink && (
            <Link to={`/data/sets/${dataSet.public_id}` as any}>
              <button className="ox-button w-26 mt-2 px-2 py-1">
                <FaEye className="mr-4 align-middle" />
                View Detail
              </button>
            </Link>
          )}
        </div>
      </div>

      {showDownloadLinks && (
        <div className="ml-4 flex flex-shrink-0 flex-col items-end">
          <h1 className={"mb-4 text-2xl font-light text-blue-200"}>Download</h1>
          <RapidDownloadOption dataSet={dataSet} />
          {ArchiveComponent && <ArchiveComponent dataSet={dataSet} refreshQuery={refreshQuery} />}
        </div>
      )}
    </Card>
  );
};
